import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FilterPipe } from './filter.pipe';
import { FindPipe } from './find.pipe';
import { FirstPipe } from './first.pipe';
import { LastPipe } from './last.pipe';
import { NonePipe } from './none.pipe';
import { NotPipe } from './not.pipe';
import { PricePipe } from './price.pipe';
import { RoundToNearestPipe } from './round-to-nearest.pipe';
import { SamePipe } from './same.pipe';
import { SanitizerPipe } from './sanitizer.pipe';
import { SomePipe } from './some.pipe';
import { SortByPipe } from './sort-by.pipe';
import { ToObjectPipe } from './to-object.pipe';



@NgModule({
    imports: [
        CommonModule,
        PricePipe,
    ],
    declarations: [
        NotPipe,
        SomePipe,
        SamePipe,
        SanitizerPipe,
        NonePipe,
        RoundToNearestPipe,
        FindPipe,
        SortByPipe,
        FilterPipe,
        ToObjectPipe,
        FirstPipe,
        LastPipe,
    ],
    exports: [
        NotPipe,
        SomePipe,
        SamePipe,
        SanitizerPipe,
        PricePipe,
        NonePipe,
        RoundToNearestPipe,
        FindPipe,
        SortByPipe,
        FilterPipe,
        ToObjectPipe,
        FirstPipe,
        LastPipe,
    ]
})
export class PipeModule {}
